"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _jsxRuntime = require("react/jsx-runtime");
(function _() {
  var styles = ".Ribbon__Left {\n  position: relative;\n  top: -0.5px;\n}";
  var fileName = "Left_Left";
  var element = document.querySelector("style[data-sass-component='Left_Left']");
  if (!element) {
    var styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
var Left = function Left() {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("svg", {
    width: "8",
    height: "48",
    viewBox: "0 0 8 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "Ribbon__Left",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 8.63675C0 8 0 43.7667 0 48.7075C0 43.7747 4.03054 40.7075 8 40.7075V0.70752C3.01492 0.70752 0 3.73753 0 8",
      fill: "#5BBC81"
    })
  });
};
var _default = Left;
exports["default"] = _default;